/* Color palette by group
     name: display name
     brand: secondary name, usually school themed for branding (optional)
     variable: variable name in mixins.scss
     hex: hex value, uppercase for design use
     contrastRatio: ratio, for design use
     type: one of [primary, secondary, white, black] for group display purposes (optional)
*/
export const NEUTRALS = [
  {
    name: 'White',
    brand: 'Milkbox',
    variable: '$white',
    hex: '#FFFFFF',
    usage: 'Text Inverse / Button Inverse / Containers / Background',
    contrastRatio: '—',
    type: 'white',
  },
  {
    name: 'N50',
    variable: '$n50',
    hex: '#F7F8F9',
    usage: 'Background Primary',
    contrastRatio: '1.1:1',
    type: 'primary',
  },
  {
    name: 'N100',
    variable: '$n100',
    hex: '#F1F2F3',
    usage: 'Background Secondary',
    contrastRatio: '1.1:1',
    type: 'primary',
  },
  {
    name: 'N200',
    variable: '$n200',
    hex: '#E6E9EC',
    usage: 'Divider Primary / Border Primary',
    contrastRatio: '1.2:1',
    type: 'primary',
  },
  {
    name: 'N300',
    variable: '$n300',
    hex: '#D6DBE0',
    usage: 'Divider Secondary',
    contrastRatio: '1.4:1',
    type: 'primary',
  },
  {
    name: 'N400',
    variable: '$n400',
    hex: '#AEB8C2',
    usage: 'Icon',
    contrastRatio: '2.0:1',
    type: 'primary',
  },
  {
    name: 'N500',
    brand: 'Playground',
    variable: '$n500',
    hex: '#8B97A2',
    usage: 'Icon on:hover',
    contrastRatio: '3.0:1',
    type: 'primary',
  },
  {
    name: 'N600',
    variable: '$n600',
    hex: '#6A7886',
    usage: 'Text Secondary',
    contrastRatio: '4.5:1',
    type: 'primary',
  },
  {
    name: 'N700',
    variable: '$n700',
    hex: '#505A65',
    usage: 'Text Primary on:hover',
    contrastRatio: '7.0:1',
    type: 'primary',
  },
  {
    name: 'N800',
    variable: '$n800',
    hex: '#47525D',
    usage: 'Background Tertiary',
    contrastRatio: '9.5:1',
    type: 'primary',
  },
  {
    name: 'N900',
    variable: '$n900',
    hex: '#313A42',
    usage: 'Text Primary',
    contrastRatio: '13.0:1',
    type: 'primary',
  },
  {
    name: 'Black',
    brand: 'Chalkboard',
    variable: '$black',
    hex: '#000000',
    usage: '—',
    contrastRatio: '—',
    type: 'black',
  },
];

export const BLUES = [
  {
    name: 'B50',
    variable: '$b50',
    hex: '#ECF5FF',
    usage: 'Background Tertiary',
    contrastRatio: '1.1:1',
  },
  {
    name: 'B100',
    variable: '$b100',
    hex: '#C0E0FD',
    usage: 'Primary Disabled / Secondary Disabled',
    contrastRatio: '1.4:1',
  },
  {
    name: 'B200',
    variable: '$b200',
    hex: '#89BFF8',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.9:1',
  },
  {
    name: 'B300',
    variable: '$b300',
    hex: '#6EA6FD',
    usage: 'Course Scholarship light accent',
    contrastRatio: '2.5:1',
  },
  {
    name: 'B400',
    brand: 'Course',
    variable: '$b400',
    hex: '#5586F8',
    usage: 'Course Scholarship',
    contrastRatio: '3.4:1',
    type: 'secondary',
  },
  {
    name: 'B500',
    brand: 'Robinson',
    variable: '$b500',
    hex: '#366AFF',
    usage: 'Action Primary / Headers / Course Scholarship on:hover',
    contrastRatio: '4.5:1',
    type: 'primary',
  },
  {
    name: 'B600',
    variable: '$b600',
    hex: '#285FF6',
    usage: 'Action Primary on:hover',
    contrastRatio: '5.2:1',
  },
  {
    name: 'B700',
    variable: '$b700',
    hex: '#2256E5',
    usage: 'Action Primary on:click',
    contrastRatio: '5.9:1',
  },
  {
    name: 'B800',
    variable: '$b800',
    hex: '#224BBE',
    usage: 'Marketing & Illustration',
    contrastRatio: '7.5:1',
  },
  {
    name: 'B900',
    variable: '$b900',
    hex: '#1D3A8A',
    usage: 'Header Seach Bar Background',
    contrastRatio: '10.4:1',
  },
];

export const CYANS = [
  {
    name: 'C50',
    variable: '$c50',
    hex: '#EBFEFF',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.0:1',
  },
  {
    name: 'C100',
    variable: '$c100',
    hex: '#9BFCFF',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.2:1',
  },
  {
    name: 'C200',
    variable: '$c200',
    hex: '#6AFAFF',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.4:1',
  },
  {
    name: 'C300',
    variable: '$c300',
    hex: '#6AF0FF',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.6:1',
  },
  {
    name: 'C400',
    variable: '$c400',
    hex: '#3DEBFF',
    usage: 'Test Score Scholarship light accent',
    contrastRatio: '1.8:1',
  },
  {
    name: 'C500',
    brand: 'Test Score',
    variable: '$c500',
    hex: '#14CCE6',
    usage: 'Test Score Scholarship',
    contrastRatio: '2.1:1',
    type: 'secondary',
  },
  {
    name: 'C600',
    variable: '$c600',
    hex: '#10BFD8',
    usage: 'Test Score Scholarship on:hover',
    contrastRatio: '3.5:1',
  },
  {
    name: 'C700',
    variable: '$c700',
    hex: '#02A6BD',
    usage: 'Marketing & Illustration',
    contrastRatio: '4.5:1',
  },
  {
    name: 'C800',
    variable: '$c800',
    hex: '#008396',
    usage: 'Marketing & Illustration',
    contrastRatio: '5.6:1',
  },
  {
    name: 'C900',
    variable: '$c900',
    hex: '#056980',
    usage: 'Marketing & Illustration',
    contrastRatio: '6.8:1',
  },
];

export const VIOLETS = [
  {
    name: 'V50',
    variable: '$v50',
    hex: '#F7F2FF',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.1:1',
  },
  {
    name: 'V100',
    variable: '$v100',
    hex: '#CCAEFF',
    usage: 'College Event Scholarship light accent',
    contrastRatio: '1.5:1',
  },
  {
    name: 'V200',
    brand: 'College Event',
    variable: '$v200',
    hex: '#A97FF3',
    usage: 'College Event Scholarship',
    contrastRatio: '3.0:1',
    type: 'secondary',
  },
  {
    name: 'V300',
    variable: '$v300',
    hex: '#8B5EDA',
    usage: 'College Event Scholarship on:hover / Community Service Scholarship light accent',
    contrastRatio: '4.5:1',
  },
  {
    name: 'V400',
    variable: '$v400',
    hex: '#784ACA',
    usage: 'Marketing & Illustration',
    contrastRatio: '5.8:1',
  },
  {
    name: 'V500',
    brand: 'Volunteer',
    variable: '$v500',
    hex: '#673AB7',
    usage: 'Community Service Scholarship light accent',
    contrastRatio: '7.3:1',
    type: 'secondary',
  },
  {
    name: 'V600',
    variable: '$v600',
    hex: '#5D2FB0',
    usage: 'Community Service Scholarship',
    contrastRatio: '8.4:1',
  },
  {
    name: 'V700',
    variable: '$v700',
    hex: '#4E229B',
    usage: 'Community Service Scholarship on:hover',
    contrastRatio: '10.4:1',
  },
  {
    name: 'V800',
    variable: '$v800',
    hex: '#401689',
    usage: 'Marketing & Illustration',
    contrastRatio: '12.4:1',
  },
  {
    name: 'V900',
    variable: '$v900',
    hex: '#2F0A70',
    usage: 'Marketing & Illustration',
    contrastRatio: '15.0:1',
  },
];

export const PINKS = [
  {
    name: 'P50',
    variable: '$p50',
    hex: '#FFEAEA',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.2:1',
  },
  {
    name: 'P100',
    variable: '$p100',
    hex: '#FFCFD9',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.4:1',
  },
  {
    name: 'P200',
    variable: '$p200',
    hex: '#FFA9BA',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.8:1',
  },
  {
    name: 'P300',
    variable: '$p300',
    hex: '#FF8AA1',
    usage: 'Marketing & Illustration',
    contrastRatio: '2.2:1',
  },
  {
    name: 'P400',
    variable: '$p400',
    hex: '#FD7791',
    usage: 'Art and Media Scholarship light accent',
    contrastRatio: '2.6:1',
  },
  {
    name: 'P500',
    brand: 'Art and Media',
    variable: '$p500',
    hex: '#FF6986',
    usage: 'Art and Media Scholarship',
    contrastRatio: '2.8:1',
    type: 'secondary',
  },
  {
    name: 'P600',
    variable: '$p600',
    hex: '#E1516D',
    usage: 'Art and Media Scholarship on:hover',
    contrastRatio: '3.8:1',
  },
  {
    name: 'P700',
    variable: '$p700',
    hex: '#CD4661',
    usage: 'Marketing & Illustration',
    contrastRatio: '4.5:1',
  },
  {
    name: 'P800',
    variable: '$p800',
    hex: '#AF364E',
    usage: 'Marketing & Illustration',
    contrastRatio: '6.1:1',
  },
  {
    name: 'P900',
    variable: '$p900',
    hex: '#9A263D',
    usage: 'Marketing & Illustration',
    contrastRatio: '7.7:1',
  },
];

export const REDS = [
  {
    name: 'R50',
    variable: '$r50',
    hex: '#FFF3F3',
    usage: 'Messaging Background',
    contrastRatio: '1.2:1',
  },
  {
    name: 'R100',
    variable: '$r100',
    hex: '#FFDFDF',
    usage: 'Action Negative Disabled',
    contrastRatio: '1.2:1',
  },
  {
    name: 'R200',
    variable: '$r200',
    hex: '#F29999',
    usage: 'Marketing & Illustration',
    contrastRatio: '2.1:1',
  },
  {
    name: 'R300',
    variable: '$r300',
    hex: '#E97474',
    usage: 'Marketing & Illustration',
    contrastRatio: '2.9:1',
  },
  {
    name: 'R400',
    variable: '$r400',
    hex: '#E25656',
    usage: 'Marketing & Illustration',
    contrastRatio: '3.7:1',
  },
  {
    name: 'R500',
    brand: 'Detention',
    variable: '$r500',
    hex: '#D83A3A',
    usage: 'Alert Text',
    contrastRatio: '4.6:1',
    type: 'secondary',
  },
  {
    name: 'R600',
    variable: '$r600',
    hex: '#CB3737',
    usage: 'Alert Text on:hover',
    contrastRatio: '5.1:1',
  },
  {
    name: 'R700',
    variable: '$r700',
    hex: '#BF2525',
    usage: 'Alert Text on:click',
    contrastRatio: '6.0:1',
  },
  {
    name: 'R800',
    variable: '$r800',
    hex: '#B01515',
    usage: 'Marketing & Illustration',
    contrastRatio: '7.1:1',
  },
  {
    name: 'R900',
    variable: '$r900',
    hex: '#A20505',
    usage: 'Marketing & Illustration',
    contrastRatio: '8.2:1',
  },
];

export const MARIGOLDS = [
  {
    name: 'M50',
    variable: '$m50',
    hex: '#FFF9E5',
    usage: 'Messaging Background',
    contrastRatio: '1.1:1',
  },
  {
    name: 'M100',
    variable: '$m100',
    hex: '#FFEFBB',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.1:1',
  },
  {
    name: 'M200',
    variable: '$m200',
    hex: '#FFE288',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.3:1',
  },
  {
    name: 'M300',
    variable: '$m300',
    hex: '#FFD75D',
    usage: 'Honor or Award Scholarship light accent',
    contrastRatio: '1.4:1',
  },
  {
    name: 'M400',
    variable: '$m400',
    hex: '#FFD040',
    usage: 'Honor or Award Scholarship',
    contrastRatio: '1.5:1',
    type: 'secondary',
  },
  {
    name: 'M500',
    variable: '$m500',
    hex: '#FFC000',
    usage: 'Honors or Award Scholarship on:hover / Activity Scholarship light accent',
    contrastRatio: '1.6:1',
  },
  {
    name: 'M600',
    variable: '$m600',
    hex: '#FF9800',
    usage: 'Activity Scholarship',
    contrastRatio: '2.2:1',
    type: 'secondary',
  },
  {
    name: 'M700',
    variable: '$m700',
    hex: '#EF8006',
    usage: 'Activity Scholarship on:hover / Work Scholarship Light Accent',
    contrastRatio: '2.7:1',
  },
  {
    name: 'M800',
    variable: '$m800',
    hex: '#C94E00',
    usage: 'Work Scholarship / Warning Text',
    contrastRatio: '4.6:1',
    type: 'secondary',
  },
  {
    name: 'M900',
    variable: '$m900',
    hex: '#B54203',
    usage: 'Work Scholarship on:hover',
    contrastRatio: '5.6:1',
  },
];

export const GREENS = [
  {
    name: 'G50',
    variable: '$g50',
    hex: '#DEFFEB',
    usage: 'Messaging Background',
    contrastRatio: '1.1:1',
  },
  {
    name: 'G100',
    variable: '$g100',
    hex: '#9FFFD5',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.2:1',
  },
  {
    name: 'G200',
    variable: '$g200',
    hex: '#62ECAC',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.5:1',
  },
  {
    name: 'G300',
    variable: '$g300',
    hex: '#22D683',
    usage: 'Marketing & Illustration',
    contrastRatio: '1.9:1',
  },
  {
    name: 'G400',
    variable: '$g400',
    hex: '#1CC979',
    usage: 'Marketing & Illustration',
    contrastRatio: '2.2:1',
  },
  {
    name: 'G500',
    variable: '$g500',
    hex: '#3EB670',
    usage: 'Referral Scholarship light accent',
    contrastRatio: '2.6:1',
  },
  {
    name: 'G600',
    variable: '$g600',
    hex: '#2FA861',
    usage: 'Referral Scholarship',
    contrastRatio: '3.0:1',
    type: 'secondary',
  },
  {
    name: 'G700',
    variable: '$g700',
    hex: '#1F874A',
    usage: 'Success Text / Referral Scholarship on:hover',
    contrastRatio: '4.5:1',
    type: 'secondary',
  },
  {
    name: 'G800',
    variable: '$g800',
    hex: '#147C3F',
    usage: 'Success Text on:hover',
    contrastRatio: '5.3:1',
  },
  {
    name: 'G900',
    variable: '$g900',
    hex: '#0D6732',
    usage: 'Success Text on:click',
    contrastRatio: '7.0:1',
  },
];

export const COLOR_PALETTE = NEUTRALS.concat(BLUES, CYANS, VIOLETS, PINKS, REDS, MARIGOLDS, GREENS);
